import React, { useState } from 'react';
import { Typography } from '@mui/material';

import PhoneBase from '../../Interface/PhoneBase/PhoneBase';
import TabsUI from '../../Interface/TabsUI';
import InprogressPurchaseDelivery from './InprogressPurchaseDelivery';
import NewPurchaseDelivery from './NewPurchaseDelivery';
import PurchaseDeliveryDocsTab from './PurchaseDeliveryDocsTab';

const PurchaseDeliveryPage = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      id: 0,
      name: 'Bizonylatok',
      content: <PurchaseDeliveryDocsTab />,
    },
    {
      id: 1,
      name: 'Új indítása',
      content: <NewPurchaseDelivery />,
    },
    {
      id: 2,
      name: 'Folyamatban',
      content: <InprogressPurchaseDelivery />,
    },
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <PhoneBase name="PurchaseDelivery">
      <Typography variant="h5" sx={{ fontWeight: 400, py: 1, px: 2 }}>
        Árubeérkezés
      </Typography>
      <TabsUI activeTab={activeTab} handleTabClick={handleTabClick} disablePadding>
        {tabs.map((tab, index) => (
          <div key={index} name={tab.name}>
            {tab.content}
          </div>
        ))}
      </TabsUI>
    </PhoneBase>
  );
};

export default PurchaseDeliveryPage;
